<template>
	<div>
		<div class="fs4 fw7 lh125 mt6 mb2">Type of license currently held.</div>
		<case-form :schema="schemaType" />

		<case-form :schema="schema" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			Number of hours flown as pilot or crew.
		</div>
		<case-form :schema="schemaHours" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			Purpose of your aviation activities.
		</div>
		<case-form :schema="schemaPurpose" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			Type of aviation activities (check all that apply)
		</div>
		<case-form :schema="schemaActivities" />

		<div class="xs-12 fs4 fw7 mb2 mt6">
			Normal aviation patterns (between what locations)
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Aviation Pattern</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaPatterns(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<div class="fs4 fw7 lh125 mt6 mb2">Type of aircraft</div>
		<case-form :schema="schemaTypeOfAircraft" />
		<case-form :schema="schemaOthers" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaType() {
			return [
				{
					label: "Student",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasStudentAviationLicense`,
					props: {
						suggest: {
							typeIncludes: `hasStudentAviationLicense`
						},
						createOptions: {
							type: `hasStudentAviationLicense`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Recreational",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasRecreationalAviationLicense`,
					props: {
						suggest: {
							typeIncludes: `hasRecreationalAviationLicense`
						},
						createOptions: {
							type: `hasRecreationalAviationLicense`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Private",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPrivateAviationLicense`,
					props: {
						suggest: {
							typeIncludes: `hasPrivateAviationLicense`
						},
						createOptions: {
							type: `hasPrivateAviationLicense`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Commercial",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasCommercialAviationLicense`,
					props: {
						suggest: {
							typeIncludes: `hasCommercialAviationLicense`
						},
						createOptions: {
							type: `hasCommercialAviationLicense`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Airline Transport",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasAirlineTransportAviationLicense`,
					props: {
						suggest: {
							typeIncludes: `hasAirlineTransportAviationLicense`
						},
						createOptions: {
							type: `hasAirlineTransportAviationLicense`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schema() {
			return [
				{
					label: "Do you hold a valid instrument rating?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasValidAviationInstrumentRating`,
					props: {
						suggest: {
							typeIncludes: `hasValidAviationInstrumentRating`
						},
						createOptions: {
							type: `hasValidAviationInstrumentRating`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Total hours in command",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationTotalHoursInCommand`,
					props: {
						suggest: {
							typeIncludes: `aviationTotalHoursInCommand`
						},
						createOptions: {
							type: `aviationTotalHoursInCommand`,
							dataType: "number"
						}
					}
				},
				{
					label: "Will you be changing your aviation activities in the future?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0willChangeAviationActivities`,
					props: {
						suggest: {
							typeIncludes: `willChangeAviationActivities`
						},
						createOptions: {
							type: `willChangeAviationActivities`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0changeAviationActivitiesDetails`,
					props: {
						suggest: {
							typeIncludes: `changeAviationActivitiesDetails`
						},
						createOptions: {
							type: `changeAviationActivitiesDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaHours() {
			return [
				{
					label: "Last 12 Months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0flyTimeInLast12Months`,
					props: {
						suggest: {
							typeIncludes: `flyTimeInLast12Months`
						},
						createOptions: {
							type: `flyTimeInLast12Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Last 12 -24 Months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0flyTimeInLast24Months`,
					props: {
						suggest: {
							typeIncludes: `flyTimeInLast24Months`
						},
						createOptions: {
							type: `flyTimeInLast24Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Expected in next 12 Months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0flyTimeInNext12Months`,
					props: {
						suggest: {
							typeIncludes: `flyTimeInNext12Months`
						},
						createOptions: {
							type: `flyTimeInNext12Months`,
							dataType: "number"
						}
					}
				},
				{
					label: "Date of last flight",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0dateOfLastFlight`,
					props: {
						suggest: {
							typeIncludes: `dateOfLastFlight`
						},
						createOptions: {
							type: `dateOfLastFlight`,
							dataType: "date"
						}
					}
				},
				{
					label: "Flight from",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0dateOfLastFlightFrom`,
					props: {
						suggest: {
							typeIncludes: `dateOfLastFlightFrom`
						},
						createOptions: {
							type: `dateOfLastFlightFrom`,
							dataType: "string"
						}
					}
				},
				{
					label: "Flight to",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0dateOfLastFlightTo`,
					props: {
						suggest: {
							typeIncludes: `dateOfLastFlightTo`
						},
						createOptions: {
							type: `dateOfLastFlightTo`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPurpose() {
			return [
				{
					label: "Pleasure",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForPleasure`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForPleasure`
						},
						createOptions: {
							type: `isAviationActivitiesForPleasure`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Business",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForBusiness`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForBusiness`
						},
						createOptions: {
							type: `isAviationActivitiesForBusiness`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Commercial",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForCommercial`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForCommercial`
						},
						createOptions: {
							type: `isAviationActivitiesForCommercial`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Military",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForMilitary`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForMilitary`
						},
						createOptions: {
							type: `isAviationActivitiesForMilitary`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Others",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForOther`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForOther`
						},
						createOptions: {
							type: `isAviationActivitiesForOther`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "(details)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationActivitiesForOtherDetails`,
					props: {
						suggest: {
							typeIncludes: `aviationActivitiesForOtherDetails`
						},
						createOptions: {
							type: `aviationActivitiesForOtherDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaActivities() {
			return [
				{
					label: "Charter",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeCharter`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeCharter`
						},
						createOptions: {
							type: `isAviationActivityTypeCharter`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Freight Transport",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeFreightTranspo`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeFreightTranspo`
						},
						createOptions: {
							type: `isAviationActivityTypeFreightTranspo`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Instructions",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeInstruction`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeInstruction`
						},
						createOptions: {
							type: `isAviationActivityTypeInstruction`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Survey/Mapping ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeSurvey`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeSurvey`
						},
						createOptions: {
							type: `isAviationActivityTypeSurvey`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Test",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeTest`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeTest`
						},
						createOptions: {
							type: `isAviationActivityTypeTest`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Sight Seeing",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeSightSeeing`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeSightSeeing`
						},
						createOptions: {
							type: `isAviationActivityTypeSightSeeing`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Crop Dusting",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeCrop`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeCrop`
						},
						createOptions: {
							type: `isAviationActivityTypeCrop`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Commercial Photography",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypePhotography`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypePhotography`
						},
						createOptions: {
							type: `isAviationActivityTypePhotography`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Aerobatics",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeAerobatics`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeAerobatics`
						},
						createOptions: {
							type: `isAviationActivityTypeAerobatics`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Others",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeOther`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeOther`
						},
						createOptions: {
							type: `isAviationActivityTypeOther`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "(Details)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationActivitiesTypeOtherDetails`,
					props: {
						suggest: {
							typeIncludes: `aviationActivitiesTypeOtherDetails`
						},
						createOptions: {
							type: `aviationActivitiesTypeOtherDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTypeOfAircraft() {
			return [
				{
					label: "Fixed Wing",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isFixedWingAircraftType`,
					props: {
						suggest: {
							typeIncludes: `isFixedWingAircraftType`
						},
						createOptions: {
							type: `isFixedWingAircraftType`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Helicopter",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isHelicopterAircraftType`,
					props: {
						suggest: {
							typeIncludes: `isHelicopterAircraftType`
						},
						createOptions: {
							type: `isHelicopterAircraftType`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Hot air Balloon",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isHotAirBalloonAircraftType`,
					props: {
						suggest: {
							typeIncludes: `isHotAirBalloonAircraftType`
						},
						createOptions: {
							type: `isHotAirBalloonAircraftType`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Ultralight",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isUltralightAircraftType`,
					props: {
						suggest: {
							typeIncludes: `isUltralightAircraftType`
						},
						createOptions: {
							type: `isUltralightAircraftType`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaOthers() {
			return [
				{
					label: "Make and model of aircraft flown",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0makeAndModelOfAircraft`,
					props: {
						suggest: {
							typeIncludes: `makeAndModelOfAircraft`
						},
						createOptions: {
							type: `makeAndModelOfAircraft`,
							dataType: "string"
						}
					}
				},
				{
					label: "Number of engines",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aircraftNumberOfEngines`,
					props: {
						suggest: {
							typeIncludes: `aircraftNumberOfEngines`
						},
						createOptions: {
							type: `aircraftNumberOfEngines`,
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>Type of Engine</div>`
					},
					bindTo: ""
				},
				{
					label: "Propeller",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isPropellerAircraftEngine`,
					props: {
						suggest: {
							typeIncludes: `isPropellerAircraftEngine`
						},
						createOptions: {
							type: `isPropellerAircraftEngine`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Jet",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isJetAircraftEngine`,
					props: {
						suggest: {
							typeIncludes: `isJetAircraftEngine`
						},
						createOptions: {
							type: `isJetAircraftEngine`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Total hours in aircraft currently flying",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0totalHoursInCurrentAircraft`,
					props: {
						suggest: {
							typeIncludes: `totalHoursInCurrentAircraft`
						},
						createOptions: {
							type: `totalHoursInCurrentAircraft`,
							dataType: "number"
						}
					}
				},
				{
					label:
						"Have you flown or do you contemplate flying an experimental/homebuilt aircraft?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasFlownExperimentalAircraft`,
					props: {
						suggest: {
							typeIncludes: `hasFlownExperimentalAircraft`
						},
						createOptions: {
							type: `hasFlownExperimentalAircraft`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, is the aircraft certified?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isExperimentalAircraftCertified`,
					props: {
						suggest: {
							typeIncludes: `isExperimentalAircraftCertified`
						},
						createOptions: {
							type: `isExperimentalAircraftCertified`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Country/authority providing certification",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0experimentalAircraftCert`,
					props: {
						suggest: {
							typeIncludes: `experimentalAircraftCert`
						},
						createOptions: {
							type: `experimentalAircraftCert`,
							dataType: "string"
						}
					}
				},
				{
					label:
						" As a pilot, have you ever had an accident, been grounded, fined or reprimanded for a violation of air regulations?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasAccidentAsPilot`,
					props: {
						suggest: {
							typeIncludes: `hasAccidentAsPilot`
						},
						createOptions: {
							type: `hasAccidentAsPilot`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0accidentAsPilotDetails`,
					props: {
						suggest: {
							typeIncludes: `accidentAsPilotDetails`
						},
						createOptions: {
							type: `accidentAsPilotDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "What type of medical certificate do you have?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0typeOfMedicalCert`,
					props: {
						suggest: {
							typeIncludes: `typeOfMedicalCert`
						},
						createOptions: {
							type: `typeOfMedicalCert`,
							dataType: "string"
						}
					}
				},
				{
					label: "Date of last renewal",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0medicalCertDateOfLastRenewal`,
					props: {
						suggest: {
							typeIncludes: `medicalCertDateOfLastRenewal`
						},
						createOptions: {
							type: `medicalCertDateOfLastRenewal`,
							dataType: "date"
						}
					}
				},
				{
					label: "Has your medical certificate ever been denied?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMedicalCertBeenDenied`,
					props: {
						suggest: {
							typeIncludes: `hasMedicalCertBeenDenied`
						},
						createOptions: {
							type: `hasMedicalCertBeenDenied`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0medicalCertBeenDeniedDetails`,
					props: {
						suggest: {
							typeIncludes: `medicalCertBeenDeniedDetails`
						},
						createOptions: {
							type: `medicalCertBeenDeniedDetails`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaPatterns(i) {
			return [
				{
					label: "From",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationPatternFrom${i}`,
					props: {
						suggest: {
							typeIncludes: `aviationPatternFrom${i}`
						},
						createOptions: {
							type: `aviationPatternFrom${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: "To",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationPatternTo${i}`,
					props: {
						suggest: {
							typeIncludes: `aviationPatternTo${i}`
						},
						createOptions: {
							type: `aviationPatternTo${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
